import {
    DESCRIPTION_ITEM_TYPES_FETCHING,
    DESCRIPTION_ITEM_TYPES_FETCHING_SUCCESS,
    DESCRIPTION_ITEM_TYPES_FETCHING_FAILURE
} from '../actions/types'


const INITIAL_STATE = {
    fetching: false,
    items: []
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DESCRIPTION_ITEM_TYPES_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case DESCRIPTION_ITEM_TYPES_FETCHING_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: prepareItems(action.payload)
            }

        case DESCRIPTION_ITEM_TYPES_FETCHING_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

const prepareItems = (items) => {
    return items.map(({
        id,
        name,
    }) => ({
        id,
        name,
    }))
}

export default reducer
